import api from './api';
import { Brand } from '../types';

export interface CreateBrandData {
  name: string;
  status?: 'active' | 'inactive';
  is_supplier?: boolean;
}

export interface UpdateBrandData {
  name?: string;
  status?: 'active' | 'inactive';
  is_supplier?: boolean;
}

export interface BrandFilters {
  search?: string;
  status?: 'active' | 'inactive';
  is_supplier?: boolean;
}

export const brandService = {
  getAll: async (filters?: BrandFilters): Promise<Brand[]> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value));
        }
      });
    }
    const queryString = params.toString();
    const url = queryString ? `/api/brands?${queryString}` : '/api/brands';
    const response = await api.get(url);
    return response.data.data || [];
  },

  getById: async (id: number): Promise<Brand> => {
    const response = await api.get(`/api/brands/${id}`);
    return response.data.data;
  },

  create: async (brandData: CreateBrandData): Promise<Brand> => {
    const response = await api.post('/api/brands', brandData);
    return response.data.data;
  },

  update: async (id: number, brandData: UpdateBrandData): Promise<Brand> => {
    const response = await api.put(`/api/brands/${id}`, brandData);
    return response.data.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/brands/${id}`);
  },
};

